import React, { useEffect, useState } from "react";
import { convertDateToSODTimestamp } from "../../../utils/dateutils";
import IntentType from "../../../intentexecutor/utils/IntentType";
import ErrorNotificationComponent from "../../../components/generic/error/ErrorNotificationComponent";
import { executeIntent } from "../../utils/IntentExecutor";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { Avatar, Badge, Spin, Typography } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { descriptionString } from "../../carecoordinator/auditlog/utils";
import { performPostRequest } from "../../../service/network/NetworkService";
import { getApiUrl } from "../../../service/network/UrlMapper";;

const NotificationIcon = () => {
  const userDetails = useReadMemory(MemoryType.USER);
  const [notifications, setNotifications] = useState([]);
  const [notificationsLoading, setNotificationsLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notificationLength, setNotificationLength] = useState(0);
  const [notificationDescription, setNotificationDescription] = useState({});

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getNotificationString = async () => {
    const payload = {
      userIdentifier: userDetails?.userIdentifier,
    };
    try {
      const response = await executeIntent(
        IntentType.GET_UNREAD_NOTIFICATION_COUNT,
        payload
      );
      setNotificationLength(response.unreadNotificaionCount);
    } catch (error) {
      ErrorNotificationComponent(error);
    } finally {
      setNotificationsLoading(false);
    }
  };
  const getNotifications = async () => {
    const payload = {
      timestamp: convertDateToSODTimestamp(
        new Date().setDate(new Date().getDate() - 5)
      ),
      userIdentifier: userDetails?.userIdentifier,
    };
    setNotificationsLoading(true);

    try {
      const response = await executeIntent(
        IntentType.GET_NOTIFICATION,
        payload
      );
      setNotifications(response.reverse());      
    } catch (error) {
      ErrorNotificationComponent(error);
    } finally {
      setNotificationsLoading(false);
    }
  };

  const getNotificatioString = (string, data) => {
    const parsedData = JSON.parse(data.payload);
    const notificationData = { ...data, payload: parsedData };
    return descriptionString(string, notificationData);
  };

  
  useEffect(() => {
    const getNotificationDescriptionData = async () => {
      const notificationDescriptionpayload = {
        intent: "get_configuration",
        payload: {
          configurationKey: ["niramaya.notifications.description"],
        },
        context: {},
      };
      try {
        let result = await performPostRequest(
          getApiUrl()[IntentType.GET_CONFIGURATION],
          JSON.stringify(notificationDescriptionpayload)
        );

        result = await result.json();

        if (result[0].configurationValue) {
          const notificationDescriptionData = JSON.parse(result[0].configurationValue);
          setNotificationDescription(notificationDescriptionData);
        }
      } catch (error) {
        ErrorNotificationComponent(error);
      }
    };

    getNotificationDescriptionData();
  }, []);

  useEffect(() => {
    getNotifications();
    getNotificationString();
  }, [notificationDescription]);

  return (
    <>
      <IconButton
        size="large"
        aria-label="notification"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        color="inherit"
        onClick={handleMenu}
      >
        <Badge count={notificationLength}>
          <Avatar
            style={{
              backgroundColor: "var(--main-theme-color)",
            }}
            icon={<BellOutlined />}
          />
        </Badge>
      </IconButton>

      {notifications.length > 0 && (
        <Menu
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          className="notifications-menu"
        >
          <div className="notifications-scrollable-div">
            {notificationsLoading && (
              <MenuItem>
                <Spin
                  size="medium"
                  className="d-flex justify-content-center align-items-center m-5 "
                />
              </MenuItem>
            )}
            {notifications.map((item) => (
              <MenuItem key={item.id}>
                <Typography textAlign="center">
                  {getNotificatioString(
                    notificationDescription?.[item.eventType],
                    item
                  )}
                </Typography>
              </MenuItem>
            ))}
          </div>
        </Menu>
      )}
    </>
  );
};

export default NotificationIcon;
